import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, nextTick } from 'vue'
  import InterestedCategoriesContents from '@/components/personal-landing-page/InterestedCategoriesContents.vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useSegment from '@/composables/useSegment'
  import useToursAndHints from '@/composables/useToursAndHints'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Library',
  setup(__props) {

  const { isDesktopDevice } = useBreakpoint()
  const { showOrHideToursAndHints, hideAllHints } = useToursAndHints()
  const { translateString } = useI18n()

  const libraryBullets = [
    translateString('library.bullets.bullet1'),
    translateString('library.bullets.bullet2'),
    translateString('library.bullets.bullet3'),
  ]
  const { checkmark } = useIcons()
  const { trackPage, pageViewed } = useSegment()

  onMounted(() => {
    trackPage('Library')
    pageViewed('Library')
    nextTick(() => {
      if (isDesktopDevice.value) showOrHideToursAndHints()
    })
  })

  onUnmounted(() => {
    hideAllHints()
  })

return { __sfc: true,isDesktopDevice, showOrHideToursAndHints, hideAllHints, translateString, libraryBullets, checkmark, trackPage, pageViewed, onMounted, onUnmounted, nextTick, InterestedCategoriesContents, useIcons, SVGRenderer, useSegment, useToursAndHints, useBreakpoint, useI18n }
}

})